export default {
    location: null,
    workOrderInvoiceId: null
}
